import React from 'react';
import Router from './routes';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material';
import { create } from 'jss';
import { jssPreset, StylesProvider } from '@mui/styles';
import useSettings from 'src/hooks/useSettings';
import { customCreateTheme } from 'src/theme';
import GlobalStyles from './components/GlobalStyles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

export default function App() {
  const { settings } = useSettings();

  const theme = customCreateTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme,
  });

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <GlobalStyles theme={theme} />
              <Router />
            </SnackbarProvider>
          </LocalizationProvider>
        </StylesProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
